import styled from '@emotion/styled'
import React, { useEffect } from 'react'
import { Platform } from '@/firebase/firestore/Platform'
import fitty from 'fitty'
import Image from 'next/image'

type Props = {
  targetId: string
  templateColor: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7
  fontFamily: string
  uid: string
  name: string
  platform: Array<Platform>
  voiceChat: Array<0 | 1 | 2 | 3 | 4 | 5>
  playStyle: string
  fontColor: string
  playTimeWeekDayBegin: string
  playTimeWeekDayEnd: string
  playTimeWeekEndBegin: string
  playTimeWeekEndEnd: string
  hitokoto: string
  dbdSurvivor: number[]
  dbdKiller: number[]
}

export const DBD1: React.FC<Props> = ({
  targetId,
  uid,
  name,
  templateColor,
  playStyle,
  platform,
  voiceChat,
  playTimeWeekDayBegin,
  playTimeWeekDayEnd,
  playTimeWeekEndBegin,
  playTimeWeekEndEnd,
  hitokoto,
  dbdSurvivor,
  dbdKiller,
  fontFamily,
  fontColor,
}) => {
  useEffect(() => {
    fitty('#name', {
      maxSize: 13,
      minSize: 6,
    })
    fitty('#gameId', {
      maxSize: 13,
      minSize: 8,
    })
    fitty('#platform', {
      maxSize: 13,
      minSize: 8,
    })
    fitty('#voiceChat', {
      maxSize: 13,
      minSize: 8,
    })
    fitty('#playStyle', {
      maxSize: 13,
      minSize: 8,
    })
    fitty('#hitokoto', {
      maxSize: 22,
      minSize: 15,
    })
  }, [])
  return (
    <ProfileContainer>
      <ProfileInner id={targetId} fontFamily={fontFamily} color={fontColor}>
        <Image
          width="2048"
          height="1346"
          priority={true}
          unoptimized={true}
          src={`/static/images/profiles/dbd1/${templateColor}.jpeg`}
          alt={`DbD自己紹介カード ${templateColor}`}
        />
        <Name>
          <span id="name">{name}</span>
        </Name>
        <Id>
          <span id="gameId">{uid}</span>
        </Id>
        <PlatformText>
          <span id="platform">
            {platform.includes(0) && ' PC '}
            {platform.includes(1) && ' プレステ '}
            {platform.includes(2) && ' Xbox '}
            {platform.includes(3) && ' Switch '}
            {platform.includes(4) && ' モバイル '}
          </span>
        </PlatformText>
        <PlayStyle>
          <span id="playStyle">{playStyle}</span>
        </PlayStyle>
        <PlayTimeWeekDay>
          平日{playTimeWeekDayBegin}〜{playTimeWeekDayEnd}時
        </PlayTimeWeekDay>
        <PlayTimeWeekEnd>
          休日{playTimeWeekEndBegin}〜{playTimeWeekEndEnd}時
        </PlayTimeWeekEnd>
        <Hitokoto>
          <span id="hitokoto">{hitokoto}</span>
        </Hitokoto>
        {voiceChat.includes(4) && <VCNg />}
        {voiceChat.length !== 0 && !voiceChat.includes(4) && (
          <VCOk color={fontColor} />
        )}
        <VCText>
          <span id="voiceChat">
            {voiceChat.includes(0) && ' Skype '}
            {voiceChat.includes(1) && ' LINE '}
            {voiceChat.includes(2) && ' プレステ '}
            {voiceChat.includes(3) && ' Discord '}
            {voiceChat.includes(5) && ' Switch '}
          </span>
        </VCText>
        {dbdKiller.includes(0) && <Killer0 />}
        {dbdKiller.includes(1) && <Killer1 />}
        {dbdKiller.includes(2) && <Killer2 />}
        {dbdKiller.includes(3) && <Killer3 />}
        {dbdKiller.includes(4) && <Killer4 />}
        {dbdKiller.includes(5) && <Killer5 />}
        {dbdKiller.includes(6) && <Killer6 />}
        {dbdKiller.includes(7) && <Killer7 />}
        {dbdKiller.includes(8) && <Killer8 />}
        {dbdKiller.includes(9) && <Killer9 />}
        {dbdKiller.includes(10) && <Killer10 />}
        {dbdKiller.includes(11) && <Killer11 />}
        {dbdKiller.includes(12) && <Killer12 />}
        {dbdKiller.includes(13) && <Killer13 />}
        {dbdKiller.includes(14) && <Killer14 />}
        {dbdKiller.includes(15) && <Killer15 />}
        {dbdKiller.includes(16) && <Killer16 />}
        {dbdKiller.includes(17) && <Killer17 />}
        {dbdKiller.includes(18) && <Killer18 />}
        {dbdKiller.includes(19) && <Killer19 />}
        {dbdKiller.includes(20) && <Killer20 />}
        {dbdKiller.includes(21) && <Killer21 />}
        {dbdKiller.includes(22) && <Killer22 />}
        {dbdKiller.includes(23) && <Killer23 />}
        {dbdKiller.includes(24) && <Killer24 />}
        {dbdKiller.includes(25) && <Killer25 />}
        {dbdKiller.includes(26) && <Killer26 />}
        {dbdKiller.includes(27) && <Killer27 />}
        {dbdKiller.includes(28) && <Killer28 />}
        {dbdKiller.includes(29) && <Killer29 />}
        {dbdKiller.includes(30) && <Killer30 />}
        {dbdKiller.includes(31) && <Killer31 />}
        {dbdKiller.includes(32) && <Killer32 />}
        {dbdKiller.includes(33) && <Killer33 />}
        {dbdSurvivor.includes(0) && <Survivor0 />}
        {dbdSurvivor.includes(1) && <Survivor1 />}
        {dbdSurvivor.includes(2) && <Survivor2 />}
        {dbdSurvivor.includes(3) && <Survivor3 />}
        {dbdSurvivor.includes(4) && <Survivor4 />}
        {dbdSurvivor.includes(5) && <Survivor5 />}
        {dbdSurvivor.includes(6) && <Survivor6 />}
        {dbdSurvivor.includes(7) && <Survivor7 />}
        {dbdSurvivor.includes(8) && <Survivor8 />}
        {dbdSurvivor.includes(9) && <Survivor9 />}
        {dbdSurvivor.includes(10) && <Survivor10 />}
        {dbdSurvivor.includes(11) && <Survivor11 />}
        {dbdSurvivor.includes(12) && <Survivor12 />}
        {dbdSurvivor.includes(13) && <Survivor13 />}
        {dbdSurvivor.includes(14) && <Survivor14 />}
        {dbdSurvivor.includes(15) && <Survivor15 />}
        {dbdSurvivor.includes(16) && <Survivor16 />}
        {dbdSurvivor.includes(17) && <Survivor17 />}
        {dbdSurvivor.includes(18) && <Survivor18 />}
        {dbdSurvivor.includes(19) && <Survivor19 />}
        {dbdSurvivor.includes(20) && <Survivor20 />}
        {dbdSurvivor.includes(21) && <Survivor21 />}
        {dbdSurvivor.includes(22) && <Survivor22 />}
        {dbdSurvivor.includes(23) && <Survivor23 />}
        {dbdSurvivor.includes(24) && <Survivor24 />}
        {dbdSurvivor.includes(25) && <Survivor25 />}
        {dbdSurvivor.includes(26) && <Survivor26 />}
        {dbdSurvivor.includes(27) && <Survivor27 />}
        {dbdSurvivor.includes(28) && <Survivor28 />}
        {dbdSurvivor.includes(29) && <Survivor29 />}
        {dbdSurvivor.includes(30) && <Survivor30 />}
        {dbdSurvivor.includes(31) && <Survivor31 />}
        {dbdSurvivor.includes(32) && <Survivor32 />}
        {dbdSurvivor.includes(33) && <Survivor33 />}
        {dbdSurvivor.includes(34) && <Survivor34 />}
        {dbdSurvivor.includes(35) && <Survivor35 />}
        {dbdSurvivor.includes(36) && <Survivor36 />}
        {dbdSurvivor.includes(37) && <Survivor37 />}
        {dbdSurvivor.includes(38) && <Survivor38 />}
      </ProfileInner>
    </ProfileContainer>
  )
}

const ProfileContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #4c4c4c;
`

const ProfileInner = styled.div<{ fontFamily: string; color: string }>`
  position: relative;
  line-height: 0;
  width: 300px;
  * {
    line-height: 1;
    font-family: ${({ fontFamily }) => fontFamily};
    color: ${({ color }) => color};
  }
`

const Name = styled.div`
  position: absolute;
  top: 20%;
  left: 4%;
  width: 30%;
  height: 4%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-weight: bold;
  }
`

const Id = styled.div`
  position: absolute;
  top: 22.5%;
  left: 4%;
  width: 30%;
  height: 4%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-weight: bold;
  }
`

const PlatformText = styled.div`
  position: absolute;
  top: 30.5%;
  left: 4%;
  width: 30%;
  height: 4%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-weight: bold;
  }
`

const VCBase = styled.div`
  position: absolute;
  top: 39%;
  border-style: solid;
  border-width: 2px;
  border-radius: 27px;
  width: 18px;
  height: 18px;
`

const VCOk = styled(VCBase)`
  top: 35.3%;
  left: 8%;
`
const VCNg = styled(VCBase)`
  top: 39%;
  left: 4%;
`

const VCText = styled.span`
  position: absolute;
  top: 36%;
  left: 15%;
  text-align: center;
  width: 20%;
  height: 4%;
  word-break: break-all;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    text-align: center;
    font-weight: bold;
    line-height: 0.9;
  }
`

const PlayTimeBase = styled.span`
  position: absolute;
  top: 48.2%;
  left: 4%;
  font-size: 7px;
  font-weight: bold;
`

const PlayTimeWeekDay = styled(PlayTimeBase)``

const PlayTimeWeekEnd = styled(PlayTimeBase)`
  left: 20%;
`

const PlayStyle = styled.span`
  position: absolute;
  top: 54.2%;
  left: 4%;
  width: 30%;
  height: 4%;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    font-weight: bold;
    line-height: 7px;
  }
`

const KillerBase = styled.div`
  position: absolute;
  top: 19%;
  left: 39%;
  border-style: solid;
  border-color: ${({ color }) => color};
  border-width: 2px;
  border-radius: 50%;
  width: 18px;
  height: 18px;
`
const Killer0 = styled(KillerBase)``
const Killer1 = styled(KillerBase)`
  left: 48%;
`
const Killer2 = styled(KillerBase)`
  left: 55%;
`
const Killer3 = styled(KillerBase)`
  left: 62%;
`
const Killer4 = styled(KillerBase)`
  left: 69.5%;
`
const Killer5 = styled(KillerBase)`
  left: 76.5%;
`
const Killer6 = styled(KillerBase)`
  left: 85%;
`
const Killer7 = styled(KillerBase)`
  left: 91.3%;
`
const Killer8 = styled(KillerBase)`
  top: 27%;
  left: 39.3%;
`
const Killer9 = styled(KillerBase)`
  top: 27%;
  left: 48%;
`
const Killer10 = styled(KillerBase)`
  top: 27%;
  left: 55.5%;
`
const Killer11 = styled(KillerBase)`
  top: 27%;
  left: 64%;
`
const Killer12 = styled(KillerBase)`
  top: 27%;
  left: 73%;
`
const Killer13 = styled(KillerBase)`
  top: 27%;
  left: 81.5%;
`

const Killer14 = styled(KillerBase)`
  top: 27%;
  left: 89.5%;
`
const Killer15 = styled(KillerBase)`
  top: 35.5%;
  left: 40.5%;
`
const Killer16 = styled(KillerBase)`
  top: 35.5%;
  left: 48.5%;
`
const Killer17 = styled(KillerBase)`
  top: 35.5%;
  left: 56.5%;
`
const Killer18 = styled(KillerBase)`
  top: 35.5%;
  left: 64.5%;
`
const Killer19 = styled(KillerBase)`
  top: 35.5%;
  left: 71.5%;
`
const Killer20 = styled(KillerBase)`
  top: 35.5%;
  left: 78.5%;
`
const Killer21 = styled(KillerBase)`
  top: 35.5%;
  left: 85.5%;
`
const Killer22 = styled(KillerBase)`
  top: 35.5%;
  left: 91.5%;
`

const Killer23 = styled(KillerBase)`
  top: 43.5%;
  left: 40.3%;
`

const Killer24 = styled(KillerBase)`
  top: 43.5%;
  left: 49%;
`

const Killer25 = styled(KillerBase)`
  top: 43.5%;
  left: 58%;
`

const Killer26 = styled(KillerBase)`
  top: 43.5%;
  left: 66%;
`

const Killer27 = styled(KillerBase)`
  top: 43.5%;
  left: 75%;
`

const Killer28 = styled(KillerBase)`
  top: 43.5%;
  left: 82.5%;
`

const Killer29 = styled(KillerBase)`
  top: 43.5%;
  left: 90.5%;
`

const Killer30 = styled(KillerBase)`
  top: 50.5%;
  left: 41%;
`

const Killer31 = styled(KillerBase)`
  top: 50.5%;
  left: 52%;
`

const Killer32 = styled(KillerBase)`
  top: 50.5%;
  left: 62%;
`

const Killer33 = styled(KillerBase)`
  top: 50.5%;
  left: 72%;
`

const SurvivorBase = styled.div`
  position: absolute;
  top: 59%;
  left: 38.5%;
  border-style: solid;
  border-color: ${({ color }) => color};
  border-width: 2px;
  border-radius: 50%;
  width: 18px;
  height: 18px;
`

const Survivor0 = styled(SurvivorBase)``
const Survivor1 = styled(SurvivorBase)`
  left: 45%;
`
const Survivor2 = styled(SurvivorBase)`
  left: 52%;
`
const Survivor3 = styled(SurvivorBase)`
  left: 59%;
`
const Survivor4 = styled(SurvivorBase)`
  left: 65.5%;
`
const Survivor5 = styled(SurvivorBase)`
  left: 72%;
`

const Survivor6 = styled(SurvivorBase)`
  left: 78%;
`

const Survivor7 = styled(SurvivorBase)`
  left: 85%;
`

const Survivor8 = styled(SurvivorBase)`
  left: 91%;
`

const Survivor9 = styled(SurvivorBase)`
  top: 66.5%;
  left: 38.5%;
`

const Survivor10 = styled(SurvivorBase)`
  top: 66.5%;
  left: 44.5%;
`

const Survivor11 = styled(SurvivorBase)`
  top: 66.5%;
  left: 51.5%;
`

const Survivor12 = styled(SurvivorBase)`
  top: 66.5%;
  left: 58.5%;
`

const Survivor13 = styled(SurvivorBase)`
  top: 66.5%;
  left: 65.5%;
`
const Survivor14 = styled(SurvivorBase)`
  top: 66.5%;
  left: 73.5%;
`

const Survivor15 = styled(SurvivorBase)`
  top: 66.5%;
  left: 82%;
`

const Survivor16 = styled(SurvivorBase)`
  top: 66.5%;
  left: 89%;
`

const Survivor17 = styled(SurvivorBase)`
  top: 75%;
  left: 38.5%;
`

const Survivor18 = styled(SurvivorBase)`
  top: 75%;
  left: 45.5%;
`

const Survivor19 = styled(SurvivorBase)`
  top: 75%;
  left: 52%;
`

const Survivor20 = styled(SurvivorBase)`
  top: 75%;
  left: 59%;
`

const Survivor21 = styled(SurvivorBase)`
  top: 75%;
  left: 65%;
`

const Survivor22 = styled(SurvivorBase)`
  top: 75%;
  left: 72%;
`

const Survivor23 = styled(SurvivorBase)`
  top: 75%;
  left: 78%;
`

const Survivor24 = styled(SurvivorBase)`
  top: 75%;
  left: 85%;
`
const Survivor25 = styled(SurvivorBase)`
  top: 75%;
  left: 92%;
`
const Survivor26 = styled(SurvivorBase)`
  top: 83.5%;
  left: 39.5%;
`
const Survivor27 = styled(SurvivorBase)`
  top: 83.5%;
  left: 46.5%;
`
const Survivor28 = styled(SurvivorBase)`
  top: 83.5%;
  left: 54%;
`
const Survivor29 = styled(SurvivorBase)`
  top: 83.5%;
  left: 62%;
`
const Survivor30 = styled(SurvivorBase)`
  top: 83.5%;
  left: 69%;
`
const Survivor31 = styled(SurvivorBase)`
  top: 83.5%;
  left: 76%;
`
const Survivor32 = styled(SurvivorBase)`
  top: 83.5%;
  left: 83%;
`
const Survivor33 = styled(SurvivorBase)`
  top: 83.5%;
  left: 90.5%;
`
const Survivor34 = styled(SurvivorBase)`
  top: 90.5%;
  left: 39.5%;
`
const Survivor35 = styled(SurvivorBase)`
  top: 90.5%;
  left: 50%;
`
const Survivor36 = styled(SurvivorBase)`
  top: 90.5%;
  left: 59%;
`
const Survivor37 = styled(SurvivorBase)`
  top: 90.5%;
  left: 67%;
`
const Survivor38 = styled(SurvivorBase)`
  top: 90.5%;
  left: 74%;
`

const Hitokoto = styled.div`
  position: absolute;
  top: 65%;
  left: 4%;
  height: 30%;
  width: 30%;
  word-break: break-all;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-weight: bold;
    line-height: 0.9;
  }
`
